import { withLazyComponent } from '@document/utils/lazy-component';
import { lazy } from 'react';

export const OfferScorecardsPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./OfferScorecardsPage')).OfferScorecardsPage,
  }))
);
